import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getHasElementsInArray } from 'utils';
import {
  DataRoomRFICategory,
  FileTypeRFI,
} from 'router/subrouters/DataRoom/models/DataRoomRfi';
import FileIcon from 'icons/File.icon';
import RfiCategoryDrawerFile from 'router/subrouters/DataRoom/subrouters/RFI/pages/RfiDetails/components/RfiCategoryDrawer/components/RfiCategoryDrawerFile';
import RfiActivityEmptyState from '../RfiActivityEmptyState';
import { getSortedCategoryFiles } from 'router/subrouters/DataRoom/subrouters/RFI/pages/RfiDetails/utils';

import './RfiActivityAdditionalFiles.styles.scss';

type RfiActivityAdditionalFilesProps = {
  className?: string;
  category: DataRoomRFICategory;
  onFileUpdate: (file: FileTypeRFI) => void;
};

const RfiActivityAdditionalFiles: React.FC<RfiActivityAdditionalFilesProps> = ({
  className,
  category,
  onFileUpdate,
}) => {
  const { t } = useTranslation();

  const classes = classNames('rfi-activity-additional-files', className);

  const files = useMemo(
    () => getSortedCategoryFiles(category?.files),
    [category],
  );

  if (!getHasElementsInArray(files))
    return (
      <RfiActivityEmptyState
        Icon={FileIcon}
        title={t('activityNoAdditionalFilesTitle')}
        description={t('activityNoAdditionalFilesDescription')}
      />
    );

  return (
    <div className={classes}>
      <p className="rfi-activity-additional-files__description">
        {t('activitySentByRecipientsNotRequested')}
      </p>

      <ul>
        {files.map((file) => (
          <RfiCategoryDrawerFile
            key={file._id}
            file={file}
            categoryId={category._id}
            onFileUpdate={onFileUpdate}
          />
        ))}
      </ul>
    </div>
  );
};

export default RfiActivityAdditionalFiles;
